module.exports = __webpack_public_path__ + "fonts/Arnhem-Normal.eac2f25.woff";